export default {
  primeiroRegistro: {},
  ultimoRegistro: {},
  itens: {},
  mediaItens: {},
  ticketMedio: {},
  cupons: {},
  faturamento: {},
  clientesTotal: {},
  clientesAtivos: {},
  clientesChart: {},
  clientesFidelidade: {},
  clientesFora: {},
  inicioFidelidade: {},
  cuponsUltimos: {},
}
